import React from 'react'
import NewsSection from './Section/NewsSection'

const News = () => {
  return (
    <div>
        <NewsSection/>
    </div>
  )
}

export default News
